module["exports"] = [
  "Øvre",
  "Nedre",
  "Søndre",
  "Gamle",
  "Østre",
  "Vestre"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/street_prefix.js
// module id = 1481
// module chunks = 0